import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WebsiteBlogListLayer from "../components/WebsiteBlogListLayer";

const WebsiteBlogListPage = () => {
    return (
        <MasterLayout>
            <WebsiteBlogListLayer />
        </MasterLayout>
    );
};

export default WebsiteBlogListPage;
